import { collectionGroup, query, where } from "firebase/firestore";
import { firestore } from "services/firebaseService/firebaseConfig";

export const USER_SESSION_EVENTS_REF = "UserSessionsEvents";

export const getEventUserSessionsRef = (eventId: string) =>
  query(
    collectionGroup(firestore, USER_SESSION_EVENTS_REF),
    where("eventId", "==", eventId),
  );
